import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 25-sep-2026 — Chrome ofrecía "Desbloquea tu cuenta para ver sugerencias de
// autocompletado" sobre campos del ERP (buscador de OT, descripción) y el globo
// quedaba pegado cuando React volvía a pintar la tabla debajo. Ningún campo de la
// app es de usuario/contraseña salvo el login, así que se marca autocomplete="off"
// en todo input/textarea que no lo declare, también en los que se montan después.
const apagarAutocompletado = (raiz) => {
  raiz.querySelectorAll?.("input:not([autocomplete]):not([type=password]), textarea:not([autocomplete])")
    .forEach((el) => el.setAttribute("autocomplete", "off"));
};
apagarAutocompletado(document);
new MutationObserver((cambios) => {
  for (const c of cambios) for (const n of c.addedNodes) if (n.nodeType === 1) apagarAutocompletado(n);
}).observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
